<div class="loader-container" *ngIf="loginHint">
    <host-app-token-loader [loginHint]="loginHint">
    </host-app-token-loader>
  </div>
<div class="global"></div>